import React from 'react';
import {FormControl, Input, InputLabel} from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import {EditCompanyProfileMarginTop20} from "./EditCompanyProfile/style";

const UploadLegalAgreement = (props) => {
  const {classes, handleFileUpload, error, helperText} = props;

  return (
    <EditCompanyProfileMarginTop20 item className={classes}>
      <FormControl variant="standard" className={".ss-byb-details-input"}>
        <InputLabel id='ssLegalAgreement' variant={'standard'} color={'primary'} shrink={true}>Legal Agreement</InputLabel>
        <Input
          className='ss-byb-details-input'
          type={'file'}
          onChange={handleFileUpload}
          error={error}
        />
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </FormControl>
    </EditCompanyProfileMarginTop20>
  )
}

export default UploadLegalAgreement;
